module.exports = __webpack_public_path__ + "assets/svg/Icons/32/calendarsync-gray-839202.svg";